// Marquee設定
const MarqueeConfig = {
  scrollEnabled: false, // スクロール連動のon/off
  
  // スクロール連動を有効化
  enableScroll() {
    this.scrollEnabled = true;
    console.log('Marquee scroll interaction enabled');
    // 再初期化でScrollTriggerを有効化
    this.reinitialize();
  },
  
  // スクロール連動を無効化
  disableScroll() {
    this.scrollEnabled = false;
    console.log('Marquee scroll interaction disabled');
    // ScrollTriggerを無効化し、本来の方向を復元
    this.reinitialize();
  },
  
  // スクロール連動を切り替え
  toggleScroll() {
    this.scrollEnabled = !this.scrollEnabled;
    console.log(`Marquee scroll interaction ${this.scrollEnabled ? 'enabled' : 'disabled'}`);
    this.reinitialize();
  },
  
  // マーキーを再初期化
  reinitialize() {
    // 既存のScrollTriggerをクリア
    ScrollTrigger.getAll().forEach(trigger => {
      if (trigger.trigger && trigger.trigger.hasAttribute('data-marquee-scroll-direction-target')) {
        trigger.kill();
      }
    });
    
    // マーキーを再初期化
    setTimeout(() => {
      initMarqueeScrollDirection();
    }, 50);
  }
};

function initMarqueeScrollDirection() {
  document.querySelectorAll('[data-marquee-scroll-direction-target]').forEach(marquee => {
    // Query marquee elements
    const marqueeContent = marquee.querySelector('[data-marquee-collection-target]');
    const marqueeScroll = marquee.querySelector('[data-marquee-scroll-target]');
    if (!marqueeContent || !marqueeScroll) return;

    // 幅が正しく計算されるまで待機
    const waitForDimensions = () => {
      return new Promise(resolve => {
        const checkDimensions = () => {
          if (marqueeContent.offsetWidth > 0 && window.innerWidth > 0) {
            resolve();
          } else {
            requestAnimationFrame(checkDimensions);
          }
        };
        checkDimensions();
      });
    };

    // 初期化を遅延実行
    waitForDimensions().then(() => {
      // Get data attributes
      const {
        marqueeSpeed: speed,
        marqueeDirection: direction,
        marqueeDuplicate: duplicate,
        marqueeScrollSpeed: scrollSpeed,
      } = marquee.dataset;

      // Convert data attributes to usable types
      const marqueeSpeedAttr = parseFloat(speed);
      const marqueeDirectionAttr = direction === 'right' ? 1 : -1; // 1 for right, -1 for left
      const duplicateAmount = parseInt(duplicate || 0);
      const scrollSpeedAttr = parseFloat(scrollSpeed);
      const speedMultiplier = window.innerWidth < 479 ? 0.25 : window.innerWidth < 991 ? 0.5 : 1;

      // 最小速度を設定して異常に速くなることを防ぐ
      let marqueeSpeed = marqueeSpeedAttr * (marqueeContent.offsetWidth / window.innerWidth) * speedMultiplier;
      marqueeSpeed = Math.max(marqueeSpeed, 3); // 最小3秒

      // Precompute styles for the scroll container
      marqueeScroll.style.marginLeft = `${scrollSpeedAttr * -1}%`;
      marqueeScroll.style.width = `${scrollSpeedAttr * 2 + 100}%`;

      // Duplicate marquee content
      if (duplicateAmount > 0) {
        const fragment = document.createDocumentFragment();
        for (let i = 0; i < duplicateAmount; i++) {
          fragment.appendChild(marqueeContent.cloneNode(true));
        }
        marqueeScroll.appendChild(fragment);
      }

      // GSAP animation for marquee content
      const marqueeItems = marquee.querySelectorAll('[data-marquee-collection-target]');
      const animation = gsap
        .to(marqueeItems, {
          xPercent: -100, // Move completely out of view
          repeat: -1,
          duration: marqueeSpeed,
          ease: 'linear',
        })
        .totalProgress(0.5);

      // Initialize marquee in the correct direction
      gsap.set(marqueeItems, { xPercent: marqueeDirectionAttr === 1 ? 100 : -100 });
      animation.timeScale(marqueeDirectionAttr); // Set correct direction
      animation.play(); // Start animation immediately

      // Set initial marquee status
      marquee.setAttribute('data-marquee-status', 'normal');

      // ScrollTrigger logic for direction inversion (条件付き)
      if (MarqueeConfig.scrollEnabled) {
        ScrollTrigger.create({
          trigger: marquee,
          start: 'top bottom',
          end: 'bottom top',
          onUpdate: self => {
            // スクロール連動が無効な場合は何もしない
            if (!MarqueeConfig.scrollEnabled) return;
            
            const isInverted = self.direction === 1; // Scrolling down
            const currentDirection = isInverted ? -marqueeDirectionAttr : marqueeDirectionAttr;

            // Update animation direction and marquee status
            animation.timeScale(currentDirection);
            marquee.setAttribute('data-marquee-status', isInverted ? 'normal' : 'inverted');
          },
        });

        // Extra speed effect on scroll (条件付き)
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: marquee,
            start: '0% 100%',
            end: '100% 0%',
            scrub: 0,
          },
        });

        const scrollStart = marqueeDirectionAttr === -1 ? scrollSpeedAttr : -scrollSpeedAttr;
        const scrollEnd = -scrollStart;

        tl.fromTo(marqueeScroll, { x: `${scrollStart}vw` }, { x: `${scrollEnd}vw`, ease: 'none' });
      } else {
        // スクロール連動無効時：各マーキーの本来の方向を維持
        // data-marquee-direction属性に基づいて固定方向を設定
        animation.timeScale(marqueeDirectionAttr);
        marquee.setAttribute('data-marquee-status', 'normal');
      }
    });
  });
}

// Initialize Marquee with Scroll Direction
document.addEventListener('DOMContentLoaded', () => {
  // 画像やCSSの読み込み完了を待つ
  if (document.readyState === 'loading') {
    window.addEventListener('load', () => {
      setTimeout(initMarqueeScrollDirection, 100);
    });
  } else {
    setTimeout(initMarqueeScrollDirection, 100);
  }
});

// グローバルからアクセス可能にする
window.MarqueeConfig = MarqueeConfig;
